
import React, { useEffect, useRef, useState } from "react";

// ✅ Reusable SlideDown Animation Component
export const SlideDown =({ show, children }) => {
    const ref = useRef(null);
    const [height, setHeight] = useState("0px");

    useEffect(() => {
        if (show) {
            const scrollHeight = ref.current.scrollHeight;
            setHeight(scrollHeight + "px");
            setTimeout(() => setHeight("auto"), 300);
        } else {
            //const currentHeight = ref.current.scrollHeight;
            //setHeight(currentHeight + "px");
            //requestAnimationFrame(() => setHeight("0px"));
            //const currentHeight = ref.current.scrollHeight;
            //setHeight(currentHeight + "px");

            //// ✅ Force reflow before collapsing
            //ref.current.offsetHeight;
            //setHeight("0px");


            const scrollHeight = ref.current.scrollHeight;
            setHeight(scrollHeight + "px");
            setTimeout(() => setHeight("0"), 300);


            //setHeight(currentHeight + "px");
            //requestAnimationFrame(() => {
            //    requestAnimationFrame(() => setHeight("0px"));
            //});
        }
    }, [show]);

    return (
        <div
            ref={ref}
            className={`slide-wrapper ${show ? "open" : "closed"}`}
            style={{
                height,
                overflow: "hidden",
                transition: "height 0.3s ease, opacity 0.3s ease, transform 0.3s ease",
                transform: show ? "translateY(0)" : "translateY(-10px)",
                opacity: show ? 1 : 0,
            }}
        >
            {children}
        </div>
    );
}